import React, {Component} from 'react'
import { NavLink } from 'react-router-dom'
import './ThankYou.css'

class ThankYou extends Component {

	render(){
		return (
			<div className="thank-you-container">
				<div className="thank-you-background"></div>
				<div className="thank-you-content">
					<strong>Thank You!</strong><br /><br />
					We will try to get back to you<br/>as soon as possible.
					<br /><br /><br /><br />

					<NavLink className="main-menu-active" end to="/">
						<button className="thank-you-button">Close</button>
					</NavLink>
				</div>
			</div>
		)
	}
}

export default ThankYou